import React from 'react';

export default function PageContent(props) {
	return (
		<React.Fragment>
			<div className="container p-10 md:pt-14 md:px-20">
				{props.children}
			</div>
		</React.Fragment>
	);
}
